import { API_CALL } from '../middleware/api';

export const CHATWOOT_SESSION = 'chatwoot/session';

export const chatwootSession = () => ({
  type: CHATWOOT_SESSION,
  [API_CALL]: {
    endpoint: 'portal/v2/chatwoot/session',
    method: 'get',
  },
});
